import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ModalWindow from '../ModalWindow/ModalWindow';
import Button from '../ui/Button/Button';
import { getIsOldAppVersion } from '../../../redux/version/version-selectors';
import { SET_IS_OLD_APP_VERSION } from '../../../redux/version/version-actions';
import './versionCheck.scss';

const VersionCheck = () => {
  const isOldVersion = useSelector(getIsOldAppVersion);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleReloadPage = () => {
    dispatch(SET_IS_OLD_APP_VERSION(false));
    window.location.reload();
  };

  // Dismissible on purpose: a hard reload would drop an ongoing consultation or call.
  const handleCancelReload = () => {
    dispatch(SET_IS_OLD_APP_VERSION(false));
  };

  return (
    <ModalWindow open={isOldVersion} onlyContent>
      <div className="versionCheckBox">
        <div className="title">{t('newVersionTitle')}</div>
        <div className="text">{t('newVersionText')}</div>
        <div className="buttonBox">
          <Button
            onClick={handleReloadPage}
            className="btn"
            text={t('reload')}
            type="button"
          />
          <Button
            onClick={handleCancelReload}
            className="btn"
            secondary
            text={t('cancelButton')}
            type="button"
          />
        </div>
      </div>
    </ModalWindow>
  );
};

export default VersionCheck;
